import {
	IStyleSettingsCarouselUploaderContext,
	StyleSettingsCarouselUploaderContext,
} from '../styleSettingsCarouselUploaderState/styleSettingsCarouselUploaderContext';
import Text from 'components/Text/Text';
import React, { useContext, useState, useEffect } from 'react';
import { TLanguageIDs, TMediaFileType } from 'types';
import { postMediaFileForStyleSettings } from 'backend/additionalInformation';
import classNames from 'classnames';
import style from './UploadVideo.module.scss';

interface IUploadVideo {
	onUploadItem: (mediaFileType: TMediaFileType, sourceUrl: string, fileId: string) => void;
	IdForInput: string;
	languageId: TLanguageIDs | null;
	groupId: string;
	videoMaxFileSizeMB: number;
	showGroupLoader: () => void;
	hideGroupLoader: () => void;
	isDisabledControls?: boolean;
}

const UploadVideo: React.FC<IUploadVideo> = ({
	onUploadItem,
	IdForInput,
	languageId,
	videoMaxFileSizeMB,
	showGroupLoader,
	hideGroupLoader,
	isDisabledControls,
}) => {
	const { changeTypeOfErrorModalWindow } = useContext<IStyleSettingsCarouselUploaderContext>(
		StyleSettingsCarouselUploaderContext,
	);
	const uploadBtnClasses = classNames(style.btn, {
		[style.activeBtn]: !isDisabledControls,
	});

	// TODO think about it later.
	const [dataToUpload, setDataToUpload] = useState<{
		status: 'success' | 'error';
		sourceUrl?: string | null;
		fileId?: string | null;
	}>();

	useEffect(() => {
		if (dataToUpload?.status === 'success' && dataToUpload.sourceUrl && dataToUpload.fileId) {
			onUploadItem(2, dataToUpload.sourceUrl, dataToUpload.fileId);
			hideGroupLoader();
		} else if (dataToUpload?.status === 'error') {
			hideGroupLoader();
			changeTypeOfErrorModalWindow('fileUploadError');
		}
		setDataToUpload(undefined);
	}, [dataToUpload]);

	const sendForm = async (video: File) => {
		const formData = new FormData();
		formData.append('file', video, video.name);
		const sourceUrl = URL.createObjectURL(video);
		try {
			languageId && showGroupLoader();
			const response = await postMediaFileForStyleSettings(formData);
			setDataToUpload({ status: 'success', sourceUrl, fileId: response.data.fileId });
			// onUploadItem(2, sourceUrl, response.data.fileId);
		} catch (err) {
			// changeTypeOfErrorModalWindow('fileUploadError');
			setDataToUpload({ status: 'error' });
		} finally {
			// hideGroupLoader();
		}
	};
	// TODO think about it later.

	const handleChangeFile = (el: React.ChangeEvent<HTMLInputElement>) => {
		el.preventDefault();
		const videoFile = el.target.files ? el.target.files[0] : '';
		if (!videoFile) {
			return;
		} else if (videoFile.size > 1000 * 1000 * videoMaxFileSizeMB) {
			changeTypeOfErrorModalWindow('videoFileSizeExceeded');
		} else if (videoFile.type === 'video/mp4' || videoFile.type === 'video/x-m4v') {
			sendForm(videoFile);
		} else {
			changeTypeOfErrorModalWindow('invalidFileFormat');
		}
		el.target.value = '';
	};

	return (
		<div>
			<input
				id={IdForInput}
				className={style.hidden}
				type="file"
				accept="video/mp4,video/x-m4v"
				onChange={handleChangeFile}
				data-test="uploadVideoButton"
			/>
			<div className={style.btnWrapper}>
				<label className={style.label} htmlFor={isDisabledControls ? undefined : IdForInput}>
					<Text
						className={uploadBtnClasses}
						translationNameSpace="form"
						translationKey="uploadVideoButton"
						theme="contrast"
						size="s"
						weight="bold"
					/>
				</label>
			</div>
		</div>
	);
};

export default UploadVideo;
